<template>
  <v-sheet
    v-if="content"
    class="d-flex flex-md-column flex-row align-items-center justify-content-around rounded-pill py-0"
    :elevation="$store.state.module.view_dark ? 0: 4"
    :class="{
      'bg-transparent border border-white' : $store.state.module.view_dark,
    }"
    :style="{
      height: $vuetify.breakpoint.smAndDown ? '60px' : '220px',
      width: $vuetify.breakpoint.smAndDown ? '220px' : '60px',
      marginTop : $vuetify.breakpoint.smAndUp ? '13px' : content.type != 'quiz' && !isMobile ? '-15px': ''
    }"
    style="box-shadow: rgba(94, 86, 105, 0.56) 1px 1px 4px 1px !important;"
  >
    <v-tooltip
      right
      max-width="300px"
    >
      <template #activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          color="primary"
          outlined
          fab
          small
          class="border border-nitro d-flex align-items-center justify-center"
          :class="{
            'bg-transparent border-white bg-inDarkActive' : $store.state.module.view_dark,
          }"
          v-on="on"
          @click="$store.state.module.view_dark = !$store.state.module.view_dark"
        >
          <img
            :src="`/images/moon_${$store.state.module.view_dark ? 'white' : 'color'}.png`"
            width="25px"
          >
        </v-btn>
      </template>
      <span>Ativar modo noturno</span>
    </v-tooltip>
    <div
      class="d-flex flex-md-column flex-row align-items-center"
      style="gap: 10px;"
    >
      <RateButton action-value="positive" />
      <RateButton action-value="negative" />
    </div>
    <TicketCreate />
  </v-sheet>
</template>
<script>
import { mapGetters } from "vuex";
import TicketCreate from '@/common/components/TicketCreate.vue';
import RateButton from './RateButton';
export default {
  components: { TicketCreate, RateButton },
  computed:{
    ...mapGetters(['module','contents','activeTab','content']),
  },
}
</script>
<style lang="css" scoped>
.bg-inDarkActive:active {
  background-color: rgba(6, 1, 129, 0.3) !important;
}
</style>